<template>
  <el-container class="app-wrapper" :class="{ 'is-collapse': isCollapse }">
    <!-- 顶部导航 -->
    <el-header height="60px" class="app-header">
      <div class="header-left">
        <div class="logo" :style="{ width: isCollapse ? '64px' : '170px' }" @click="_toIndex">
          <i class="el-icon-s-home" style="font-size: 24px;"></i>
        </div>
        <!-- 折叠切换按钮 -->
        <div class="collapse-btn" @click="toggleCollapse">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </div>
      </div>
      <div class="header-right">
        <el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">
          <span class="user-info">
            {{ curCommunityName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>
            <el-dropdown-item command="moreCommunity" class="moreCommunity">{{ $t('layout.moreCommunity')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="margin-left">{{ systemInfo.version }}</span>

      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 -->
      <el-aside class="app-aside" :width="isCollapse ? '64px' : '170px'">
        <el-menu :default-active="activeMenu" :default-openeds="openedMenus" :collapse="isCollapse" class="sidebar-menu"
          background-color="#304156" text-color="#bfcbd9" active-text-color="#409EFF" @select="handleMenuSelect">
          <!-- 扁平化菜单：原二级菜单作为一级显示-->
          <template v-for="(menu, index) in flattenedMenus">
            <!-- 有子菜单的显示为 submenu -->
            <el-submenu v-if="hasVisibleChildren(menu)" :index="String(menu.id || menu.mId)"
              :key="'sub-' + index + '-' + (menu.id || menu.mId)">
              <template slot="title">
                <i :class="'fa ' + (menu.icon || 'fa-circle')"></i>
                <span slot="title">{{ menu.name }}</span>
              </template>
              <!-- 子菜单项 -->
              <el-menu-item v-for="(subMenu, subIndex) in getVisibleSubMenus(menu)" :index="subMenu.href"
                :key="'child-' + index + '-' + subIndex">
                {{ subMenu.name }}
              </el-menu-item>
            </el-submenu>
            <!-- 无子菜单的直接作为菜单项 -->
            <el-menu-item v-else :index="menu.href || String(menu.id || menu.mId)"
              :key="'item-' + index + '-' + (menu.id || menu.mId)">
              <i :class="'fa ' + (menu.icon || 'fa-circle')"></i>
              <span slot="title">{{ menu.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>

      <!-- 主要内容区-->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>
    <more-community ref="moreCommunity" />
    <view-menu-user-list ref="viewMenuUserModel" />
    <search-community-data-list ref="searchCommunityDataModel" />
  </el-container>
</template>

<script>
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi'
import { getStoreInfo } from "@/api/user/indexApi"
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentCommunity } from "@/utils/vc"
import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi'
import moreCommunity from '@/components/community/moreCommunity.vue'
import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import { initSystem } from '@/api/util/vcApi'
import config from '@/conf/config'


// 需要隐藏的菜单名称配置
//hiddenMenuConfig: {
//  level1: ['设备', '订单', '商城', '营销', '运营', '费用', '停车', '巡检', '合同', '优惠', '预约'],  // 隐藏的一级菜
//  level2: ['周边商家', '店铺信息', '小区店铺', '优惠, '优惠券订]  // 隐藏的二级菜
// }

export default {
  name: 'Layout',
  data() {
    return {
      catalogs: [],
      activeMenu: '',
      username: '',
      curCommunityName: '',
      communitys: [],
      storeInfo: {
        storeTypeCd: '',
        storeId: '',
        levelCd: ''  // 添加 levelCd 字段
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: ''
      },
      isCollapse: false,        // 侧边栏折叠状态
      fullMenuTree: [],         // 完整的菜单树
      openedMenus: [],          // 当前展开的菜单数组
      menuCache: null,          // 菜单数据缓存
      menuCacheExpiry: 0,       // 缓存过期时间戳
      hiddenMenuConfig: {
       level1: ['设备', '订单', '商城', '营销', '运营', 'OA','费用', '办公','停车', '巡检', '合同', '优惠', '预约'],  // 隐藏的一级菜单
       level2: []  // 隐藏的二级菜单
      }
    }
  },
  async created() {
    let _user = JSON.parse(localStorage.getItem('user'));
    this.username = _user.name
    this.systemInfo.version = config.version
    
    this.getSystemInfo()
    await this._loadStoreInfo()
    
    // 根据用户角色动态设置隐藏菜单（从localStorage的user中获取levelCd）
    this.setHiddenMenusByRole(_user)
    
    this.loadFullMenuTree()  // 替换原有?loadCatalogs 调用，加载完整菜单树
    this.curCommunityName = getCommunityName()
    this.loadCommunity()
    initSystem()
  },
  components: {
    moreCommunity,
    viewMenuUserList,
    searchCommunityDataList
  },
  watch: {
    /**
     * 监听路由变化，同步菜单状态
     * Requirements: 5.1, 5.2, 5.3
     */
    $route: {
      handler() {
        // 路由变化时同步菜单激活状态
        this.setActiveMenuByRoute()
      },
      immediate: true  // 页面刷新时也触发，恢复菜单状态
    }
  },
  computed: {
    /**
     * 扁平化菜单：将所有catalog下的菜单合并显示
     */
    flattenedMenus() {
      const result = []
      const seenIds = new Set()  // 用于去重

      for (const catalog of this.fullMenuTree) {
        const menus = catalog.menus || []
        for (const menu of menus) {
          const menuId = menu.id || menu.mId
          // 只添加可见的菜单，排除隐藏列表中的菜单，并去重
          if (this.isMenuVisible(menu) &&
            !this.hiddenMenuConfig.level1.includes(menu.name) &&
            !seenIds.has(menuId)) {
            result.push(menu)
            seenIds.add(menuId)
          }
        }
      }
      // 按seq排序
      result.sort((a, b) => (a.seq || 0) - (b.seq || 0))
      return result
    }
  },
  methods: {
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle
      this.systemInfo.companyName = data[0].companyName
      this.systemInfo.logoUrl = data[0].logoUrl
    },
    async loadCommunity() {
      const { communitys } = await _loadCommunityInfo()
      this.communitys = communitys
      this.curCommunityName = getCommunityName()

    },
    async _loadStoreInfo() {
      this.loading = true
      try {
        const res = await getStoreInfo()
        deepCopy(res, this.storeInfo);
        console.log('[用户信息] storeInfo:', this.storeInfo)
      } catch (error) {
        console.log('加载用户信息失败', error)
      } finally {
        this.loading = false
      }
    },
    /**
     * 加载完整的三级菜单树
     * 合并 catalogs 和 menuTree 为统一的菜单结构
     * 使用缓存机制避免重复请求
     * Requirements: 1.1
     */
    async loadFullMenuTree() {
      // 检查缓存是否有效（缓存有效期5分钟）
      const CACHE_DURATION = 5 * 60 * 1000 // 5 minutes
      const now = Date.now()

      if (this.menuCache && this.menuCacheExpiry > now) {
        // 使用缓存数据
        this.fullMenuTree = this.menuCache
        this.setActiveMenuByRoute()
        return
      }

      // 检查sessionStorage缓存
      const cachedData = this.getMenuFromStorage()
      if (cachedData) {
        this.fullMenuTree = cachedData
        this.menuCache = cachedData
        this.menuCacheExpiry = now + CACHE_DURATION
        this.setActiveMenuByRoute()
        return
      }

      this.loading = true
      try {
        // 1. 获取一级菜?catalogs
        const catalogRes = await _getMenuCatalog()
        if (catalogRes.code != 0) {
          console.log('获取菜单目录失败')
          return
        }
        this.catalogs = catalogRes.data || []

        // 2. 为每?catalog 加载对应?menuTree
        const fullTree = []
        for (const catalog of this.catalogs) {
          try {
            const menuRes = await getMenuTree(catalog)
            const menus = menuRes.data || []


            // 对菜单进行排
            menus.sort((a, b) => a.seq - b.seq)
            // 对子菜单也进行排序（兼容 childs ?children 两种字段名）
            menus.forEach(menu => {
              const children = menu.childs || menu.children || []
              if (children.length > 0) {
                children.sort((a, b) => a.seq - b.seq)
                // 统一使用 childs 字段
                menu.childs = children
              }
            })

            fullTree.push({
              caId: catalog.caId,
              name: catalog.name,
              icon: catalog.icon || 'fa-folder',
              url: catalog.url,
              menus: menus
            })
          } catch (menuError) {
            console.log(`获取菜单树失 ${catalog.name}`, menuError)
            // 即使某个 catalog 的菜单加载失败，也添加空菜单
            fullTree.push({
              caId: catalog.caId,
              name: catalog.name,
              icon: catalog.icon || 'fa-folder',
              url: catalog.url,
              menus: []
            })
          }
        }

        this.fullMenuTree = fullTree
        console.log('[菜单调试] 完整菜单', this.fullMenuTree)

        // 更新缓存
        this.menuCache = fullTree
        this.menuCacheExpiry = now + CACHE_DURATION
        this.saveMenuToStorage(fullTree)

        // 3. 根据当前路由设置激活菜
        this.setActiveMenuByRoute()

      } catch (error) {
        console.log('加载菜单失败', error)
        this.fullMenuTree = []
      } finally {
        this.loading = false
      }
    },
    /**
     * ?sessionStorage 获取缓存的菜单数
     */
    getMenuFromStorage() {
      try {
        const cached = sessionStorage.getItem('menuTreeCache')
        if (!cached) return null

        const { data, expiry } = JSON.parse(cached)
        if (Date.now() > expiry) {
          sessionStorage.removeItem('menuTreeCache')
          return null
        }
        return data
      } catch (e) {
        return null
      }
    },
    /**
     * 将菜单数据保存到 sessionStorage
     */
    saveMenuToStorage(data) {
      try {
        const CACHE_DURATION = 5 * 60 * 1000 // 5 minutes
        const cacheData = {
          data: data,
          expiry: Date.now() + CACHE_DURATION
        }
        sessionStorage.setItem('menuTreeCache', JSON.stringify(cacheData))
      } catch (e) {
        console.warn('无法缓存菜单数据?sessionStorage', e)
      }
    },
    /**
     * 清除菜单缓存（用于权限变更等场景
     */
    clearMenuCache() {
      this.menuCache = null
      this.menuCacheExpiry = 0
      sessionStorage.removeItem('menuTreeCache')
    },
    /**
     * 根据当前路由设置激活的菜单
     * Requirements: 5.1, 5.2
     */
    setActiveMenuByRoute() {
      const currentPath = this.$route.path
      if (!currentPath) return

      // 遍历扁平化菜单查找匹配的菜单
      for (const menu of this.flattenedMenus) {
        // 检查一级菜单（原二级）
        if (menu.href && this.isPathMatch(menu.href, currentPath)) {
          this.activeMenu = menu.href
          return
        }

        // 检查二级菜单（原三级）
        const children = menu.childs || menu.children || []
        for (const subMenu of children) {
          if (subMenu.href && this.isPathMatch(subMenu.href, currentPath)) {
            this.activeMenu = subMenu.href
            this.openedMenus = [menu.id || menu.mId]
            return
          }
        }
      }
    },
    /**
     * 判断路径是否匹配
     */
    isPathMatch(menuHref, routePath) {
      if (!menuHref || !routePath) return false
      // 处理 /#/ 格式的路
      let normalizedHref = menuHref.replace('/#/', '/')
      return normalizedHref === routePath || normalizedHref === routePath + '/'
    },

    handleCommand(command) {
      if (command === 'logout') {
        // 处理退出登
        localStorage.removeItem('token')
        localStorage.clear();
        sessionStorage.removeItem('menuTreeCache')  // 清除菜单缓存
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        // 切换语言
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeCommunity(community) {
      if (community == 'moreCommunity') {
        this.$refs.moreCommunity.open()
        return
      }
      setCurrentCommunity(community);
      this.curCommunityName = getCommunityName()
      window.location.href = "/"
    },
    handleMenuSelect(index) {
      // 处理菜单选择 - 路由跳转
      if (!index) return;

      // 处理外部链接
      if (index.indexOf('.html') > -1) {
        window.open(index, '_blank');
        return;
      }

      // 处理 IOT 跳转
      if (index === 'IOT') {
        jumpToIot('/');
        return;
      }

      // 处理 MALL 跳转
      if (index === 'MALL') {
        jumpToMall('/');
        return;
      }

      // 处理内部路由
      let href = index;
      if (href.indexOf('/#/') > -1) {
        href = href.replace('/#/', '/');
      }

      this.$router.push(href).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    toggleCollapse() {
      // 切换折叠状
      this.isCollapse = !this.isCollapse;
    },
    _showModelDiv: function (_catalog) {
      console.log(_catalog)
      if (_catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1, _catalog.url.length);
        this.$refs[_modelName].open()
        return true;
      }
      return false;
    },
    _toIndex() {
      location.href = '/'
    },
    /**
     * 获取可见的菜单项（二级菜单）
     * 兼容 isShow 字段可能'Y'?1'、true 等不同格
     */
    getVisibleMenus(menus) {
      if (!menus) return []
      return menus.filter(menu => {
        const isShow = menu.isShow
        return isShow === 'Y' || isShow === '1' || isShow === true || isShow === 1 || isShow === undefined
      })
    },
    /**
     * 判断单个菜单是否可见
     */
    isMenuVisible(menu) {
      const isShow = menu.isShow
      return isShow === 'Y' || isShow === '1' || isShow === true || isShow === 1 || isShow === undefined
    },
    /**
     * 判断菜单是否有可见的子菜单（二级菜单
     */
    hasVisibleChildren(menu) {
      const children = menu.childs || menu.children || []
      if (children.length === 0) return false
      // 检查是否有可见的子菜单（排除隐藏列表中的菜单）
      return children.some(child => {
        const isShow = child.isShow
        const isVisible = isShow === 'Y' || isShow === '1' || isShow === true || isShow === 1 || isShow === undefined
        return isVisible && !this.hiddenMenuConfig.level2.includes(child.name)
      })
    },
    /**
     * 获取可见的子菜单项（二级菜单
     * 兼容 childs ?children 两种字段
     */
    getVisibleSubMenus(menu) {
      const children = menu.childs || menu.children || []
      if (!children || children.length === 0) return []
      return children.filter(subMenu => {
        const isShow = subMenu.isShow
        const isVisible = isShow === 'Y' || isShow === '1' || isShow === true || isShow === 1 || isShow === undefined
        // 排除隐藏列表中的菜单
        return isVisible && !this.hiddenMenuConfig.level2.includes(subMenu.name)
      })
    },
    /**
     * 根据用户角色设置隐藏的菜
     */
    setHiddenMenusByRole(user) {
      console.log(user,'个人信息')
      // 判断是否为管理员
      // levelCd ?"00" 表示管理员，其他值（?"01"）表示员
      const isAdmin = user.levelCd == '00' || user.levelCd == 0
      
      console.log('[菜单权限] 用户信息:', user)
      console.log('[菜单权限] levelCd:', user.levelCd, '是否管理', isAdmin)
      
      if (isAdmin) {
        // 管理员隐藏个人信
        if (!this.hiddenMenuConfig.level2.includes('个人信息')) {
          this.hiddenMenuConfig.level2.push('个人信息')
          console.log('[菜单权限] 管理员隐藏个人信息菜单')
        }
      } else {
        console.log('[菜单权限] 员工可见个人信息菜单')
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
}

.app-header {
  background-color: #1e2132;
  color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  height: 100%;
}

.logo {
  width: 170px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #409EFF;
  cursor: pointer;
  background-color: #304156;
  transition: width 0.28s ease-in-out;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 折叠状态下?logo 宽度 */
.app-wrapper.is-collapse .logo {
  width: 64px;
}

.collapse-btn {
  width: 40px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  color: #fff;
  font-size: 20px;
  transition: color 0.3s;

  &:hover {
    color: #409EFF;
  }
}

.header-menu {
  border: none;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 100%;
}

.margin-left {
  margin-left: 15px;
  color: #fff;
  font-size: 12px;
}

.margin-right {
  margin-right: 15px;
}

.user-info {
  color: #fff;
  cursor: pointer;
}

.app-aside {
  transition: width 0.28s ease-in-out;
  overflow: hidden;
  background-color: #304156;
}

.sidebar-menu {
  height: calc(100vh - 60px);
  border-right: none;
  overflow-y: auto;
  overflow-x: hidden;
  transition: width 0.28s ease-in-out;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}

.app-main {
  background-color: #f5f7fa;
  height: calc(100vh - 60px);
  padding: 0px;
  overflow: auto;
}

.moreCommunity {
  font-weight: 600;
  color: #212529;
  font-size: 12px;
}

/* 深色主题样式 */
:deep(.el-menu) {
  border-right: none;
}

:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  transition: background-color 0.3s, border-color 0.3s;

  &:hover {
    background-color: #263445 !important;
  }

  i {
    color: #bfcbd9;
    margin-right: 10px;
  }
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;

  &:hover {
    background-color: #263445 !important;
  }

  &.is-active {
    background-color: #263445 !important;
    border-left: 3px solid #409EFF;
  }

  i {
    color: #bfcbd9;
    margin-right: 10px;
  }
}

/* 展开的子菜单背景?*/
:deep(.el-submenu.is-opened > .el-submenu__title) {
  background-color: #1f2d3d !important;
}

:deep(.el-submenu .el-menu) {
  background-color: #1f2d3d !important;
}

:deep(.el-submenu .el-menu .el-menu-item) {
  background-color: #1f2d3d !important;

  &:hover {
    background-color: #263445 !important;
  }

  &.is-active {
    background-color: #263445 !important;
  }
}

/* 折叠状态样?*/
:deep(.el-menu--collapse) {
  width: 64px;

  .el-submenu__title {
    padding: 0 !important;
    text-align: center;

    span {
      display: none;
    }

    i {
      margin: 0;
      font-size: 18px;
    }

    .el-submenu__icon-arrow {
      display: none;
    }
  }

  .el-menu-item {
    padding: 0 !important;
    text-align: center;

    span {
      display: none;
    }

    i {
      margin: 0;
      font-size: 18px;
    }
  }
}

/* 折叠时弹出菜单样?*/
:deep(.el-menu--popup) {
  min-width: 200px;
  background-color: #304156 !important;

  .el-menu-item {
    background-color: #304156 !important;
    color: #bfcbd9;

    &:hover {
      background-color: #263445 !important;
    }

    &.is-active {
      color: #409EFF;
      background-color: #263445 !important;
    }
  }

  .el-submenu__title {
    background-color: #304156 !important;
    color: #bfcbd9;

    &:hover {
      background-color: #263445 !important;
    }
  }
}

/* 过渡动画 */
.sidebar-menu:not(.el-menu--collapse) {
  width: 170px;
}

/* 菜单项过渡动?*/
:deep(.el-menu-item),
:deep(.el-submenu__title) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 折叠展开动画 */
:deep(.horizontal-collapse-transition) {
  transition: width 0.28s ease-in-out, padding-left 0.28s ease-in-out, padding-right 0.28s ease-in-out;
}
</style>
